import React, { Component } from 'react';
import { Link } from "react-router-dom";

import '../css/components/BlocCta.css';

class BlocCta extends Component {
  constructor (props) {
    super(props)
    this.innerClassName = "bloc bloc-cta" + (props.extraClassName ? " " + props.extraClassName : "");
    this.innerImgClassName = props.extraImgClassName;
    this.image = props.image ? props.image : {};
    this.title = props.title;
    this.subtitle = props.subtitle;
    this.link = props.link ? props.link : {};
  }

  render() {

    let link;
    if (this.link.href !== undefined) {
        if (this.link.href.startsWith('http')) {
            link = <a href={this.link.href} className="btn btn-morph">{this.link.label}</a>;
        } else {
            link = <Link to={this.link.href} className="btn btn-morph">{this.link.label}</Link>;
        }
    } else if (this.link.onClick !== undefined) {
        link = <span onClick={() => this.link.onClick()} className="btn btn-morph">{this.link.label}</span>
    } else {
        link = null;
    }

    return (
        <div className={this.innerClassName}>
            <picture className={this.innerImgClassName}>
                <img src={this.image.src} alt={this.image.alt}  />
            </picture>
            <div>
                <h4>{this.title}</h4>
                <h5 dangerouslySetInnerHTML={{ __html: this.subtitle }} />
                <h5>{this.props.children}</h5>
                {link}
            </div>
        </div>
    );
  }
}

export default BlocCta;



// WEBPACK FOOTER //
// ./src/components/BlocCta.js